import React from 'react';
import { Modal } from 'react-bootstrap';
import { useBoolean } from 'usehooks-ts';
import { HeartModalBackground } from './HeartModalBackground';
import graphql from 'babel-plugin-relay/macro';
import { useMutation } from 'react-relay';
import { AgreeTosPrivacyModalMutation } from './__generated__/AgreeTosPrivacyModalMutation.graphql';

const AgreeTosPrivacyModal = () => {
  const { value: visible, setFalse: hide } = useBoolean(true);
  const [agreeToTerms, signupInFlight] = useMutation<AgreeTosPrivacyModalMutation>(
    graphql`
      mutation AgreeTosPrivacyModalMutation {
        agreeToTerms {
          userId
        }
      }
    `);

  const agree = async (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();

    agreeToTerms({
      variables: {},
      onCompleted () {
        hide();
      }
    });

    return false;
  };
  return (
    <Modal id='agree-tos-privacy-modal' show={visible} fullscreen='sm-down' className='overflow-hidden' style={{ top: '25%' }}>
      <Modal.Header className='border-bottom-0'>
        <Modal.Title>We have updated our Terms of Use and Privacy Notice</Modal.Title>
      </Modal.Header>
      <HeartModalBackground />
      <Modal.Body>
        To continue using DNASolves®, please review and accept our updated <a href='https://othram.com/terms.html' target='_blank' rel='noopener noreferrer'>Terms of Use</a> and <a href='https://othram.com/privacy.html' target='_blank' rel='noopener noreferrer'>Privacy Notice</a>.
      </Modal.Body>
      <Modal.Footer className='border-top-0'>
        <button onClick={agree} disabled={signupInFlight} type='button' className='btn btn-primary btn-sm' data-bs-dismiss='modal'>I Agree</button>
      </Modal.Footer>
    </Modal >
  );
};

(window as any).AgreeTosPrivacyModal = AgreeTosPrivacyModal;

export default AgreeTosPrivacyModal;
